<template>
  <div
    class="card-sections-block-footer"
    v-if="this.card.status===this.$constants.card.statuses.STATUS_COMPLETED || (currentStage && currentStage.type === $constants.stage.types.TYPE_ASSESSMENT)"
  >
    <el-table
      class="card-summary-table card-section-elements-table"
      header-row-class-name="card-section-elements-table-header"
      row-class-name="evraz-summary-row"
      style="width: 100%; margin-bottom: 25px"
      :data="summary"
    >
      <el-table-column label="ИТОГО"></el-table-column>
      <el-table-column
        v-if="sections.find(s => s.type==='okr')"
        :label="'Цели (' + getSectionWeight('okr') + '%)'"
        width="150"
      >
        <template v-slot="scope">
          {{ card.info.bonus_okr|numberFormat }}
        </template>
      </el-table-column>
      <el-table-column
        v-if="sections.find(s => s.type==='key_competences')"
        :label="'Ключевые компетенции (' + getSectionWeight('key_competences') + '%)'"
        width="200"
      >
        <template v-slot="scope">
          {{ card.info.bonus_key_competences | numberFormat }}
        </template>
      </el-table-column>
      <el-table-column
        v-if="sections.find(s => s.type==='personal_competences')"
        :label="'Индивидуальные компетенции (' + getSectionWeight('personal_competences') + '%)'"
        width="200"
      >
        <template v-slot="scope">
          {{ card.info.bonus_personal_competences | numberFormat }}
        </template>
      </el-table-column>
      <el-table-column
        width="50"
      >
      </el-table-column>
      <el-table-column
        label="Итоговая оценка"
        width="150"
      >
        <template v-slot="scope">
          {{ card.bonus|numberFormat }}
        </template>
      </el-table-column>
    </el-table>

  </div>
</template>

<script>

import SearchInput from "@/components/filters/SearchInput";
import CardsYearSelect from "@/components/filters/cards/CardsYearSelect";
import CardsStageSelect from "@/components/filters/cards/CardsStageSelect";
import CardsStageNegotiationSelect from "@/components/filters/cards/CardsStageNegotiationSelect.vue";
import CardsPeriodSelect from "@/components/filters/cards/CardsPeriodSelect.vue";
import UserSelect from "@/components/filters/users/UserSelect.vue";
import CardsStatusSelect from "@/components/filters/cards/CardsStatusSelect.vue";
import {mapGetters} from "vuex";
import {downloader} from "@/mixins/downloader";
import CloneElementsFromCardModal from "@/components/cards/CloneElementsFromCardModal.vue";
import HistoryModal from "@/components/HistoryModal.vue";
import StartDynamicStageButton from "@/components/cards/StartDynamicStageButton.vue";

export default {
  name: "card-sections-block-footer",
  mixins: [downloader],
  components: {StartDynamicStageButton, HistoryModal, CloneElementsFromCardModal},
  props: {},

  computed: {
    ...mapGetters(['user']),
    ...mapGetters('card', {
      card: 'card'
    }),
    ...mapGetters('card/stages', {
      currentStage: 'currentStage',
    }),
    ...mapGetters('card/sections', {
      sections: 'sections',
      sectionsElements: 'sectionsElements',
    }),
    summary() {
      let totalWeight = 0;

      this.sections.forEach(section => {
        if( this.$companyConfiguration.cardSections.isSectionMultiplyElementsBonus(section.type) ){
          // Для кэфов не нужно считать вес
          return;
        }
        if( !this.sectionsElements[section.id] ){
          return;
        }
        this.sectionsElements[section.id].forEach(e => {
          totalWeight += +e.weight;
        })
      })

      return [{
        weight: +totalWeight.toFixed(2),
      }]
    },

    width() {
      let weightWidth = 0;
      if (this.currentStage && this.currentStage.type === this.$constants.stage.types.TYPE_PLAN) {
        weightWidth = 730;
      }
      if (this.currentStage && this.currentStage.type === this.$constants.stage.types.TYPE_CORRECTION) {
        weightWidth = 980;
      }
      if (this.currentStage && this.currentStage.type === this.$constants.stage.types.TYPE_ASSESSMENT) {
        weightWidth = 720;
      }
      if (this.card.status === this.$constants.card.statuses.STATUS_COMPLETED ) {
        weightWidth = 720;
      }
      return {
        'weight': weightWidth,
      }
    },


  },
  watch: {},
  data() {
    return {}
  },
  methods: {
    getSectionWeight(sectionType){
      if( sectionType === 'okr' ){
        if( this.sections.length === 3 || this.sections.length === 2 ){
          return 50;
        }
        return 100;
      }
      if( sectionType === 'key_competences' || sectionType === 'personal_competences' ){
        if( this.sections.length === 3 ){
          return 25;
        } else if( this.sections.length === 2 ){
          return 50;
        }
        return 100;
      }
    },
  }
}
</script>


<style lang="scss">
.evraz-summary-row{
  font-weight: bold;
}
</style>